import React from 'react'

export default props => <code style={{fontSize: 'inherit'}}>{props.children}</code>